import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/img/shouye.png';
import _imports_1 from '@/assets/img/img1.png';
const _hoisted_1 = {
  id: "HomePage"
};
const _hoisted_2 = {
  class: "header-",
  id: "headers"
};
const _hoisted_3 = {
  id: "swiper",
  class: "container-fuild"
};
const _hoisted_4 = {
  class: "swiper-container banner-swiper"
};
const _hoisted_5 = {
  class: "swiper-wrapper"
};
const _hoisted_6 = {
  class: "swiper-slide-title"
};
const _hoisted_7 = {
  style: {
    "color": "lightgrey",
    "font-size": "17px"
  }
};
const _hoisted_8 = {
  id: "whyChooseUs",
  class: "conatiner-fuild"
};
const _hoisted_9 = {
  class: "container"
};
const _hoisted_10 = {
  class: "row"
};
const _hoisted_11 = {
  class: "server-block wow slideInUp",
  onmouseenter: "this.style.color='#28f';this.style.borderColor='#28f'",
  onmouseleave: "this.style.color='#666';this.style.borderColor='#ccc'"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "text-center"
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  id: "customer",
  class: "container-fuild"
};
const _hoisted_16 = {
  class: "container customer-container"
};
const _hoisted_17 = {
  class: "swiper-container customer-swiper hidden-xs"
};
const _hoisted_18 = {
  class: "swiper-wrapper"
};
const _hoisted_19 = {
  class: "customer-logo"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "row visible-xs customer-block"
};
const _hoisted_22 = {
  class: "customer-logo"
};
const _hoisted_23 = ["src"];
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { Swiper } from 'swiper';
import { WOW } from 'wowjs';

// 使用路由

export default {
  __name: 'HomePage',
  setup(__props) {
    const router = useRouter();

    // 响应式数据
    const swiperList = ref([{
      path: "",
      title: 'Toco-Cloud云服务',
      content: '快速构建和部署智能化系统'
    }, {
      path: "",
      title: 'AI+算法',
      content: '智能分析图像声音，实现精细管控'
    }]);
    const customerList = ref([{
      logo: new URL('@/assets/img/brand/haisi.jpg', import.meta.url).href,
      title: "海思",
      content: "xxx"
    }, {
      logo: new URL('@/assets/img/brand/guokehui.jpg', import.meta.url).href,
      title: "国科微",
      content: "XXX"
    }, {
      logo: new URL('@/assets/img/brand/yiyuantonxin.jpg', import.meta.url).href,
      title: "移远通信",
      content: "xxx"
    }, {
      logo: new URL('@/assets/img/brand/guanghetong.jpg', import.meta.url).href,
      title: "广和通",
      content: "xxx"
    }, {
      logo: new URL('@/assets/img/brand/sitewei.jpg', import.meta.url).href,
      title: "斯特威电子科技",
      content: "xxx"
    }, {
      logo: new URL('@/assets/img/brand/dianxin.jpg', import.meta.url).href,
      title: "中国电信",
      content: "xxx"
    }, {
      logo: new URL('@/assets/img/brand/yidong.jpg', import.meta.url).href,
      title: "中国移动",
      content: "xxx"
    }]);
    const serverList = ref([{
      logo: new URL('@/assets/img/live.png', import.meta.url).href,
      title: "智慧生活",
      content: "<p>实时监控家庭安全，远程访问，</p>智能警报，保护您的家人和财产。"
    }, {
      logo: new URL('@/assets/img/niu.png', import.meta.url).href,
      title: "智慧生产",
      content: "<p>实现对林牧渔业环境的智能监测,</p>提高管理水平,推动养殖业智能化。"
    }, {
      logo: new URL('@/assets/img/yundongjiankang.png', import.meta.url).href,
      title: "智慧健康",
      content: "<p>健康监测，远程护理，智能诊断，</p>健康管理，关心您的身心健康。"
    }, {
      logo: new URL('@/assets/img/business.png', import.meta.url).href,
      title: "智慧商业",
      content: "<p>客流统计，智能分析，安防监控，</p>优化运营效率，增加商业价值。"
    }]);

    // 方法
    const toContactMe = () => {
      router.push("contact");
    };

    // 组件挂载后初始化
    onMounted(() => {
      // banner-swiper
      new Swiper(".banner-swiper", {
        loop: true,
        effect: 'fade',
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        lazy: {
          loadPrevNext: true
        },
        observer: true,
        observeParents: true
      });

      // customer-swiper
      new Swiper(".customer-swiper", {
        loop: true,
        slidesPerView: 3,
        autoplay: {
          delay: 900,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observer: true,
        observeParents: true
      });

      // wowjs动画
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    });
    return (_ctx, _cache) => {
      const _component_Header = _resolveComponent("Header");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Header)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(swiperList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "swiper-slide",
          key: index
        }, [_cache[2] || (_cache[2] = _createElementVNode("img", {
          class: "swiper-lazy",
          src: _imports_0,
          alt: "轮播图"
        }, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "swiper-lazy-preloader"
        }, null, -1)), _createElementVNode("div", _hoisted_6, [_cache[0] || (_cache[0] = _createElementVNode("h1", {
          class: "gradient-text"
        }, "智能视觉产品", -1)), _createElementVNode("p", _hoisted_7, _toDisplayString(item.content), 1), _cache[1] || (_cache[1] = _createElementVNode("p", {
          style: {
            "color": "#31B0D5"
          }
        }, "基于大谷 AIoT开发平台，极速研发4G、Wi-Fi等多种网络通讯协议的智能化视觉产品", -1))])]);
      }), 128))])])]), _createElementVNode("div", {
        id: "bigData",
        class: "container-fuild"
      }, [_createElementVNode("div", {
        class: "row bigData-container"
      }, [_cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "col-xs-12 col-sm-12 col-md-6 wow zoomIn"
      }, [_createElementVNode("img", {
        class: "img-responsive",
        src: _imports_1,
        alt: "大数据管理系统"
      })], -1)), _createElementVNode("div", {
        class: "col-xs-12 col-sm-12 col-md-6"
      }, [_cache[4] || (_cache[4] = _createElementVNode("h2", {
        class: "bigData-title"
      }, [_createTextVNode(" 关于大谷物联 "), _createElementVNode("small", null, "About DaGuIot")], -1)), _cache[5] || (_cache[5] = _createElementVNode("p", null, "大谷物联是行业领先的集“物联网视频云平台+产品和解决方案”为一体的创新型公司。作为国家级高新技术企业，公司以“智能视觉”为核心，致力于物联网视频监控设备、人工智能、Toco Cloud智能云服务等多项领域的研发、生产和销售。", -1)), _cache[6] || (_cache[6] = _createElementVNode("p", null, "与国内众多厂商不同，大谷物联在成立之初，就把目光瞄向了机器视觉市场。产品聚焦于家庭安防、婴幼儿监护、个人娱乐、健康看护、远程教育、车载等多个领域，并建立自有的全球化云计算系统，其产品先后在全球多地销售，获得用户的广泛认可，为用户提供专业的智能视觉产品和整体解决方案", -1)), _cache[7] || (_cache[7] = _createElementVNode("p", null, "作为摄像头行业的领先者，大谷物联提供多种解决方案，涵盖了各种应用场景，包括安防监控、智能家居、商业监控、交通监控等。公司的解决方案旨在满足客户的需求，并提供高清图像质量、智能分析功能、远程访问等先进的功能。", -1)), _cache[8] || (_cache[8] = _createElementVNode("p", null, "大谷物联的产品线包括各种类型的摄像头，如网络摄像机、高清摄像机、全景摄像机等。公司的产品以其卓越的性能、可靠性和创新性而闻名。", -1)), _cache[9] || (_cache[9] = _createElementVNode("h2", {
        class: "bigData-device"
      }, null, -1)), _createElementVNode("a", {
        href: "#",
        onClick: toContactMe,
        class: "btn btn-lg btn-block btn-info"
      }, "联系我们")])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "whyChooseUs-title text-center"
      }, [_createElementVNode("p", null, "为什么选择我们的服务"), _createElementVNode("p", null, "THE REASON TO CHOOSING US")], -1)), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serverList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "col-xs-12 col-sm-6 col-md-3 server-wrapper",
          key: index
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
          class: "center-block",
          src: item.logo,
          alt: "logo"
        }, null, 8, _hoisted_12), _createElementVNode("p", _hoisted_13, _toDisplayString(item.title), 1), _createElementVNode("div", {
          class: "text-center",
          innerHTML: item.content,
          style: {
            "color": "#666"
          },
          onmouseenter: "this.style.color='#28f'",
          onmouseleave: "this.style.color='#666'"
        }, null, 8, _hoisted_14)])]);
      }), 128))])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[12] || (_cache[12] = _createElementVNode("p", {
        class: "customer-title text-center"
      }, "合作伙伴", -1)), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "swiper-slide customer-block",
          key: index
        }, [_createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
          class: "center-block",
          src: item.logo,
          alt: "logo"
        }, null, 8, _hoisted_20)])]);
      }), 128))])]), _createElementVNode("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "col-xs-12",
          key: index
        }, [_createElementVNode("div", _hoisted_22, [_createElementVNode("img", {
          class: "center-block",
          src: item.logo,
          alt: "logo"
        }, null, 8, _hoisted_23)])]);
      }), 128))])])]), _createElementVNode("div", {
        id: "contactUs",
        class: "container-fuild text-center"
      }, [_createElementVNode("div", {
        class: "container contactUs-container wow slideInUp"
      }, [_cache[13] || (_cache[13] = _createElementVNode("h1", null, "合作联系", -1)), _cache[14] || (_cache[14] = _createElementVNode("h3", null, "我们期待与更多合作伙伴共同探索，让生活更智能，让城市更聪慧", -1)), _createElementVNode("button", {
        onClick: toContactMe,
        class: "btn btn-default btn-sm",
        onmouseleave: "this.style.borderColor='#ffffff'; this.style.backgroundColor='#ffffff'; this.style.color='#3f3f3f';",
        onmouseenter: "this.style.backgroundColor='transparent'; this.style.borderColor='#ffffff'; this.style.color='#ffffff';"
      }, "联系我们"), _cache[15] || (_cache[15] = _createElementVNode("div", {
        class: "contactUs-contactWay"
      }, [_createElementVNode("span"), _createElementVNode("span"), _createElementVNode("span")], -1))])]), _createVNode(_component_Footer)]);
    };
  }
};